import { ArrowBack, AssignmentOutlined, Close, Compare, PhotoLibraryOutlined, DescriptionOutlined, PictureAsPdf } from "@mui/icons-material";
import { AppBar, Box, CircularProgress, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const LoadingFullScreen = ({ 
  isSmallScreen, 
  series,
  homologation,
  image,
  report,
  lanzamiento
 }: { isSmallScreen: boolean, 
  series?: string,
  homologation?: string,
  image?: string,
  report?: string,
  lanzamiento?: string,
 }) => {

  const { t } = useTranslation();

  return (
    <>
    <AppBar
        color="inherit"
        position="fixed"
        sx={{
          // zIndex: (theme) => theme.zIndex.drawer,
          pt: isSmallScreen ? "56px" : "64px",
        }}
      >
        <Toolbar sx={{ p: 1 }}>
          <IconButton onClick={() => {}} color="inherit" sx={{ mr: 1 }}><ArrowBack/></IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }} />
          {/* <Typography variant="h6" sx={{ flexGrow: 1 }}>{t('inspections.seriesComparison')}</Typography> */}
          {series && (
            <Tooltip title={t('projectList.seriesBookTitle', { code: '' })} placement="bottom">
              <IconButton sx={{ mr: 0.5 }}><Compare /></IconButton>
            </Tooltip>
          )}
          {homologation && (
            <Tooltip title={t('projectList.homologationBookName')} placement="bottom">
              <IconButton sx={{ mr: 0.5 }}><AssignmentOutlined /></IconButton>
            </Tooltip>
          )}
          {image && (
            <Tooltip title={t('projectList.imageBookTitle', { code: '' })} placement="bottom">
              <IconButton sx={{ mr: 0.5 }}><PhotoLibraryOutlined /></IconButton>
            </Tooltip>
          )}
          {report && (
            <Tooltip title={t('projectList.reportTitle', { code: '' })} placement="bottom">
              <IconButton sx={{ mr: 0.5 }}><DescriptionOutlined /></IconButton>
            </Tooltip>
          )}
          {lanzamiento && (
            <Tooltip title={t('projectList.launchTitle', { code: '' })} placement="bottom">
              <IconButton sx={{ mr: 0.5 }}><PictureAsPdf /></IconButton>
            </Tooltip>
          )}
          <IconButton color="inherit"><Close /></IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: "calc(100vh - 112px - " + (isSmallScreen ? "56px" : "72px") + ")",
        mt: isSmallScreen ? "calc(56px + 56px)" : "calc(64px + 64px)",
        bgcolor: 'background.default',
        zIndex: 9999
      }}>
        <CircularProgress sx={{ position: 'absolute', top: 'calc(50% - 18px)', left: 'calc(50% - 18px)', transform: 'translate(-50%, -50%)' }} />
      </Box>
    </>
  );
};